import React from 'react'
import BuyAirtimeExcel from './BuyAirtimeExcel'
import BuyDataExcel from './BuyDataExcel'

const BuyViaExcel = () => {
  return (
    <div className="mx-auto p-4">
      {/* tabs */}
      <div role="tablist" className="tabs tabs-bordered mt-2">
        <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Buy Airtime" defaultChecked />
        <div role="tabpanel" className="tab-content py-4 overflow-hidden">
          <BuyAirtimeExcel />
        </div>

        <input type="radio" name="my_tabs_1" role="tab" className="tab whitespace-nowrap" aria-label="Buy Data" />
        <div role="tabpanel" className="tab-content py-4">
          <BuyDataExcel />
        </div>
      </div>
    </div>
  )
}

export default BuyViaExcel
